import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { GetlifeContext } from "../context/GetLifeContext.context";
import { StatusContext } from "../context/StatusContext";
import HttpLeadRepository from "../api/request/Lead/Lead.service";
import HttpBeneficiariesRepository from "../api/request/Beneficiaries/Beneficiaries.service";
import { BeneficiaryDataI } from "../api/request/Beneficiaries/Interfaces/BeneficiariesInterfaces";
import { DataI } from "../api/request/Lead/Interfaces/DataInterface.response";
import { DOMAIN } from "../constants/Global";

interface BeneficiaryITState {
  type: string;
  nominative_beneficiary: number | null;
}

/**
 * Loads the one-off data the customer dashboard needs on mount:
 * lead status, checkout data (redirects to /login on 401), IT beneficiary
 * type/resume for the IT market.
 */
export const useDashboardBootstrap = () => {
  const { leadId, token } = useContext(GetlifeContext);
  const { getStatus } = useContext(StatusContext);
  const navigate = useNavigate();

  const [userData, setUserData] = useState<DataI | undefined>();
  const [beneficiaryIT, setBeneficiaryIT] = useState<BeneficiaryITState>({
    type: "",
    nominative_beneficiary: null,
  });
  const [resumeBeneficiaryIT, setResumeBeneficiaryIT] =
    useState<BeneficiaryDataI[]>();

  useEffect(() => {
    const leadRepository = new HttpLeadRepository(leadId, token);
    const beneficiaryRepository = new HttpBeneficiariesRepository(
      leadId,
      token
    );

    getStatus();
    leadRepository.getCheckoutData().then((res) => {
      if (res.code === 401) {
        navigate("/login");
      } else {
        setUserData(res);
      }
    });

    if (DOMAIN === "it") {
      beneficiaryRepository.getTypeBeneficiaries().then((res) => {
        setBeneficiaryIT(res);
        if (res.type === "Free designation") {
          beneficiaryRepository
            .getAllResumeBeneficiaries()
            .then((resp) => setResumeBeneficiaryIT(resp));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { userData, beneficiaryIT, resumeBeneficiaryIT };
};
